import styled from 'styled-components';

export const AddVehicleTypeContainer = styled.section`
  width: 100%;
  height: fit-content;
`;
